import React, { useState, useEffect } from "react"
import _ from "lodash"

import { DateInput, NumberInput } from "components/table/carousel/inputs"
import NoneStateTrashIcon from "components/table/carousel/none-state-trash-icon"
import RowAddRemove from "components/table/carousel/row-add-remove"
import { field_attrs } from "components/table/lib/column-field"

import { checkDateSet } from "data/lib/dates"

import { FormError_s } from "styles/form-styles"
import { MultiRowCarouselState_s, SingleRowCarouselState_s } from "components/table/carousel/carousel-styles"

type Item_t = object & {
  i: number
}

const OccupiedRolloverDetailed = (props: {rowData: [], field: string, namedItems: {}, persist: Function}) => {
  const initialItems = _.get(props.rowData[props.field], "items")

  const emptyRecord = {
    percentRollToMarket: null,
    dateMode: "absolute"
  }

  const emptyItem = {
    date: null,
    unitsRolling: null
  }

  const [data, setData] = useState<object|null>(props.rowData[props.field])
  const [items, setItems] = useState<Item_t[]>(initialItems ? _.sortBy(initialItems.map((item, i) => { return {...item, i }}), "date") : [{...emptyItem, i: 0}])
  const [homogenous, setHomogenous] = useState<boolean>(true);

  function updateVal(val:any, field:any[]):void {
    let newData = _.cloneDeep(data)
    if(_.isArray(field)) {
      if(items[field[0]][field[1]] === val) return
      items[field[0]][field[1]] = val
      if (field[1] === 'date'){
        let dateModeCheck = checkDateSet(val, items)
        setHomogenous(dateModeCheck.homogenous);
        _.set(newData, 'dateMode', dateModeCheck.dateMode);
      }
    } else {
      _.set(newData, field, val)
    }
    setData(newData)
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest), "date")
    _.set(newData, 'items', strippedItems)
    if (newData.state !== 'detailed') _.set(newData, 'state', 'detailed')
    props.persist(newData, props.field, props.rowData)
  }

  function updateItems(items:Item_t[]):void {
    let newData = _.cloneDeep(data)
    const strippedItems = _.sortBy(items.map(({i, ...rest}) => rest), "date")
    _.set(newData, 'items', strippedItems)
    if (newData.state !== 'detailed') _.set(newData, 'state', 'detailed')
    props.persist(newData, props.field, props.rowData)
  }

  let renderItems = _.sortBy(items, 'i')
  const params = {
    data: items,
    persist: updateVal
  }

  useEffect(() => {
    if (_.get(props['rowData'][props.field], "state") !== 'detailed'){
      setData(emptyRecord)
      setItems([{...emptyItem, i: 0}])
    }
  }, [props['rowData']])

  const attrs = (field) => field_attrs('multifamily', props.field)(field)(props.rowData, props)
  const item_attrs = (field) => field_attrs('multifamily', `${props.field}.items`)(field)(props.rowData, props)

  return (
    <div>
      <NoneStateTrashIcon />
      <SingleRowCarouselState_s style={{marginBottom: 10}} className="carousel-single-row">
        <div>
          <label>% Roll To Market</label>
          <NumberInput className="automated" data={data} attrs={attrs} field="percentRollToMarket" readPrecision={2} writePrecision={2} persist={updateVal} />
        </div>
      </SingleRowCarouselState_s>
      { renderItems.map((row:object, i) => (
          <MultiRowCarouselState_s className="carousel-multi-row">
            <div>
              { i === 0 && <label>Date</label> }
              <DateInput className="automated" attrs={item_attrs} field={[`${row['i']}`, 'date']} {...params} allowRelative withoutDays />
            </div>
            <div>
              { i === 0 && <label>Units Expiring</label> }
              <NumberInput className="automated" attrs={item_attrs} field={[`${row['i']}`, 'unitsRolling']} {...params} readPrecision={0} writePrecision={0} />
            </div>
            <RowAddRemove emptyRecord={emptyItem} setState={updateItems} row={i} items={items} />
          </MultiRowCarouselState_s>
      ))}
      {!homogenous && <FormError_s>All dates must be either relative or absolute</FormError_s>}
    </div>
  )
}

export default OccupiedRolloverDetailed
